const commonListClasses = 'relative flex items-center flex-wrap';
const lastElementClasses = 'px-2';

const breadcrumbsCommonTheme = {
  commonListClasses,
  lastElementClasses,
};

export default breadcrumbsCommonTheme;
